import type { FeedbackClient } from '@myrewards/contracts';

/** What the browser says about itself, for the report (APP-104 §4). The sizes are the tab's, not the person's. */
export function clientState(): FeedbackClient {
  const media = (q: string): boolean | null => {
    try {
      return typeof window.matchMedia === 'function' ? window.matchMedia(q).matches : null;
    } catch {
      return null;
    }
  };
  const dark = media('(prefers-color-scheme: dark)');
  const light = media('(prefers-color-scheme: light)');
  return {
    userAgent: navigator.userAgent.slice(0, 500),
    platform: (navigator.platform || 'unknown').slice(0, 100),
    language: (navigator.language || 'unknown').slice(0, 35),
    timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown').slice(0, 64),
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
      pixelRatio: window.devicePixelRatio || 1,
    },
    screen: { width: window.screen.width, height: window.screen.height },
    online: navigator.onLine,
    colorScheme: dark === true ? 'dark' : light === true ? 'light' : 'unknown',
    reducedMotion: media('(prefers-reduced-motion: reduce)') === true,
    appVersion: __APP_VERSION__.slice(0, 64),
  };
}
